module.exports = __webpack_public_path__ + "img/21.7345be6.png";